export default __webpack_public_path__ + "static/media/business_extras.6d457a22.svg";